import React from 'react';
import { Navigate } from 'react-router-dom';
import ComponentWrapper from './ComponentWrapper';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import LoCoPilot from './components/LoCoPilot';

const RoutesConfig = [
  { path: "/", element: <ComponentWrapper component={LoCoPilot} componentName="LoCoPilot" componentPath="src/components/LoCoPilot.js" /> },
  // Retired duplicate of "/" — kept as a redirect so old links and Google's indexed copy
  // still resolve. The canonical URL is now the site root.
  { path: "/locopilot", element: <Navigate to="/" replace /> },
  { path: "/contact", element: <ComponentWrapper component={Contact} componentName="Contact" componentPath="src/components/Contact.js" /> },
  { path: "/privacy-policy", element: <ComponentWrapper component={PrivacyPolicy} componentName="PrivacyPolicy" componentPath="src/components/PrivacyPolicy.js" /> },
];

export default RoutesConfig;
